import { useState, useEffect } from "react";
import { BodyWithClass, Btn } from "@client/ui";
import { useNavigate } from "react-router-dom";

const RestaurantHeroSection: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();

  const restaurantTypes = [
    {
      type: "Restaurants",
      image: "/image/restaurant.jpg",
      description:
        "Expand your reach and serve more customers with our delivery network.",
    },
    {
      type: "Fast Food",
      image: "/image/fast-food.jpg",
      description:
        "Boost sales with quick deliveries and a broader customer base.",
    },
    {
      type: "Cafés & Bakeries",
      image: "/image/cafe.jpg",
      description:
        "Deliver fresh pastries and beverages to customers across town.",
    },
    {
      type: "Food Trucks",
      image: "/image/food-truck.jpg",
      description: "Extend your mobile business with our delivery options.",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % restaurantTypes.length);
    }, 5000); // Change every 5 seconds

    return () => clearInterval(interval);
  }, [restaurantTypes.length]);

  const navigateToRestaurantPage = () => {
    navigate("/restaurant-partner");
  };

  return (
    <div className="bg-background-light max-w-full w-[700px] m-auto py-8 px-4 rounded-[12px] mb-[50px]">
      <BodyWithClass
        className="font-primary text-[24px] text-center font-semibold"
        text="Partner Your Food Business With Tapzus"
      />
      <div className="mt-4 text-center">
        <BodyWithClass
          className="hero-section text-[20px] font-medium"
          text="Grow your food business beyond your walls"
        />
        <BodyWithClass
          className="additional-text text-[18px] text-gray-600 mt-2"
          text="Reach more customers, increase sales, and build your brand with Tapzus delivery services tailored for food businesses."
        />
        <BodyWithClass
          className="benefits-text text-[16px] text-gray-500 mt-4"
          text="Join thousands of successful food partners already growing their business with Tapzus."
        />
      </div>

      <div className="w-full border-primary border-t-1 mt-6 pt-[30px]">
        <BodyWithClass
          className="image-text text-[20px] font-medium text-center mb-4"
          text="Perfect for all food businesses"
        />

        {/* Image carousel */}
        <div className="relative h-[300px] overflow-hidden rounded-lg shadow-md">
          {/* Images with fade transition */}
          {restaurantTypes.map((restaurant, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 flex flex-col ${
                index === currentIndex ? "opacity-100 z-10" : "opacity-0 z-0"
              }`}
            >
              <div className="relative h-[220px] overflow-hidden">
                <img
                  src={restaurant.image}
                  alt={restaurant.type}
                  className="w-full h-full object-cover transition-transform duration-700 ease-in-out transform hover:scale-105"
                />
                <div className="absolute top-0 left-0 bg-gradient-to-r from-orange-800/70 to-transparent px-4 py-2 rounded-br-lg">
                  <h3 className="text-white font-bold text-lg">
                    {restaurant.type}
                  </h3>
                </div>
              </div>
              <div className="bg-white p-4 h-[80px] flex items-center justify-center">
                <p className="text-center text-gray-700">
                  {restaurant.description}
                </p>
              </div>
            </div>
          ))}

          {/* Indicator dots */}
          <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-2 z-20">
            {restaurantTypes.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-2 h-2 rounded-full transition-colors ${
                  index === currentIndex ? "bg-orange-600" : "bg-gray-300"
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="mt-8 text-center">
        <Btn
          text="Become a Food Partner"
          onClick={navigateToRestaurantPage}
          style={{
            backgroundColor: "#ea580c",
            color: "white",
            padding: "10px 24px",
            borderRadius: "8px",
            fontWeight: "600",
          }}
        />
      </div>
    </div>
  );
};

export default RestaurantHeroSection;
